export enum VotingValue {
    Positive = 'positive',
    Negative = 'negative',
}

export type VotingType = (typeof VotingValue)[keyof typeof VotingValue];
